export const leadingZero = (num, places = 2) =>
  String(num).padStart(places, '0');
